function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IcautionCircleWhite = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    notChangeable: true,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.51131 2 2.0448 6.46667 2.00035 11.9333C1.97813 14.6 3.00032 17.1333 4.88915 19.0222C6.75575 20.9333 9.26677 21.9778 11.9333 22H12C17.4887 22 21.9552 17.5333 21.9997 12.0667C22.0441 6.55556 17.5776 2.04444 12 2ZM10.875 8.63984C10.875 8.01096 11.3793 7.5 12 7.5C12.6207 7.5 13.125 8.01096 13.125 8.63984V11.9021C13.125 12.531 12.6207 13.042 12 13.042C11.3793 13.042 10.875 12.531 10.875 11.9021V8.63984ZM10.875 15.3209C10.875 14.692 11.3793 14.181 12 14.181C12.6207 14.181 13.125 14.692 13.125 15.3209V15.3602C13.125 15.989 12.6207 16.5 12 16.5C11.3793 16.5 10.875 15.989 10.875 15.3602V15.3209Z",
    fill: "white"
  }));
});